import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    backgroundColor: "#184171",
    alignItems: "center",
  },

  logoText: {
    textTransform: "uppercase",
    fontWeight: "bold",
    marginTop: 10,
    fontSize: 32,
    color: "#fff",
  },
  loginContainer: {
    backgroundColor: "#fff",
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "40%",
    borderTopLeftRadius: 100,
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    padding: 10,
    width: 280,
    height: 60,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 50,
    marginTop: "3%",
  },
  loginButton: {
    borderColor: "#1FBFB5",
    borderWidth: 2,
  },
  text: {
    textTransform: "uppercase",
    fontWeight: "700",
    letterSpacing: 1,
  },
});

export default styles;
